// extracted by mini-css-extract-plugin
module.exports = {"w1194iyg":"w1194iyg"};